import SevenChurches from '../images/7Churches.jpg';
import BibleLandsTour from '../images/BibleLandsTour.jpg';
import JourneysOfPaul from '../images/JourneysofPaul.jpg';
import EuropeanReformation from '../images/EuropeanReformation.jpg';
import USAAdventistHistory from '../images/USAAdventistHistory.jpg';
import BritishIslesChritianHistory from '../images/BritishIslesChritianHistory.jpg';

export const participantAgeRange = ['0-3', '4-11', '12-17', '18-25', '26-35', '36-45', '46-55', '56-70'];

export const tourDestinations = [
  'British Isles Christian History (Celtic, Reformation, Mayflower)',
  'European Reformation',
  '7 Churches (Patmos/Turkey)',
  'USA Adventist History',
  'Bible Lands (Israel, Jordan, Egypt)',
];

export const tourImageGallery = [
  {
    image: BritishIslesChritianHistory,
    caption: 'Christian History of the British Isles',
  },
  {
    image: EuropeanReformation,
    caption: 'European Reformation',
  },
  {
    image: BibleLandsTour,
    caption: 'Bible Lands Tour',
  },
  {
    image: SevenChurches,
    caption: 'The 7 Churches of Revelation',
  },
  {
    image: USAAdventistHistory,
    caption: 'USA Adventist History',
  },
  {
    image: JourneysOfPaul,
    caption: 'Journeys of Paul',
  },
];
